import _ from 'lodash';
import { PAYMENT_TYPE } from '$fbusiness/enums/options/paymentType';
import { CREDIT, INVOICE, PAYMENT, REFUND, REFUND_CREDIT } from '$fbusiness/enums/transactionType';
import { toCreditId } from '$fbusiness/models/credit';
import { toRefundId } from '$fbusiness/models/refund';
import { DATE_FORMATS } from '$gbusiness/enums';
import { format } from '$gbusiness/helpers/date';
import intl from '$gintl';
import {
  accessDisable,
  getAccess,
  getCommissionRate,
  getInvoice,
  isAccessible,
} from '$fbusiness/helpers/util';
import REFUND_STATUS_OPTIONS, { REFUND_STATUS } from '$fbusiness/enums/options/refundStatus';
import { Select } from '@mui/material';
import { generateSelectOptions } from '$gcomponents/utils/input';
import { dialog } from '$gcomponents/reusables';
import {
  CANCELLED_OPTIONS,
  CLOSE_OPTIONS,
  convertToOption,
  INVOICE_STATUS,
  OPEN_OPTIONS,
  REFUNDED_OPTIONS,
  VOID_PAYMENT_OPTIONS,
} from '$fbusiness/enums/options/invoiceStatus';
import { roundDecimal } from '$gbusiness/helpers/util';

// export const deriveInvoiceNo = (row) => {
//   let str = '';
//   if (row.type === INVOICE || row.type === REFUND) str += row.invoice?.invoiceNumber + ' / ';
//   if (row.type === REFUND) str += toRefundId(row.refund?.id + ' / ');
//   if (row.type === CREDIT) str = toCreditId(row.credit?.id);
//   return str;
// };

export const deriveInfo = (row) => {
  const { paymentGroup, refund, invoice, credit } = row;
  switch (row.type) {
    case INVOICE:
      return <div>{invoice?.charge && <div>{invoice.charge.name}</div>}</div>;
    case PAYMENT:
      if (!paymentGroup) return null;
      return (
        <div>
          <div>{paymentGroup?.type}</div>
          {displayPaymentInfo(paymentGroup)}
        </div>
      );
    case CREDIT:
      return (
        <div className="small">
          {invoice && <div>{invoice.invoiceNumber}</div>}
          <div className="small">{credit?.note}</div>
        </div>
      );
    case REFUND:
      if (!refund) return null;
      return (
        <div className="small">
          {refund?.payment && <div>{refund?.payment}</div>}
          {invoice && <div>{invoice.invoiceNumber}</div>}
          {refund?.note && <div>{refund?.note}</div>}
          {/* {refund?.refundedAt ? (
            <div>Processed: {format(refund.refundedAt)}</div>
          ) : (
            <div>Requested: {format(refund.requestDate)}</div>
          )} */}
        </div>
      );
    case 'REFUND_CREDIT':
      if (!refund || refund?.isCredit) return null;
      return <div className="small">#RC{refund.id}</div>;
    default:
      return null;
  }
};

export function getCommissionAmt(invoice, commission) {
  if (!invoice) return 0;
  const { taxable } = invoice;
  const commRate = getCommissionRate(invoice, commission);
  return Math.round(taxable * commRate) / 100;
}

export const deriveAmount = (row) => {
  const inv = getInvoice(row);
  let amount = 0;
  if (inv) amount = inv?.totals?.finalTotal || inv.amount || 0;
  else if (row.credit) amount = (row.credit?.totals?.finalTotal || row.amount || 0) * -1;
  else amount = row.amount || 0;
  return roundDecimal(amount, 2);
};

export const deriveOpenBalance = (row) => {
  const inv = getInvoice(row);
  let balance = 0;
  if (inv) balance = inv?.totals?.finalBalance || inv?.openBalance || 0;
  else if (row.type === REFUND) balance = row.refund?.balance || 0;
  else if (row.paymentGroup) balance = row.paymentGroup?.balance * -1;
  else if (row.type.includes(CREDIT)) balance = row.credit?.balance * -1;
  return roundDecimal(balance, 2);
};

export const displayPaymentInfo = (row) => {
  let html: any = [];
  switch (row.type) {
    case PAYMENT_TYPE.CASH:
      if (row.settings?.refNo) html.push(`Ref #${row.settings?.refNo}`);
      break;
    case PAYMENT_TYPE.CHECK:
    case PAYMENT_TYPE.ACH:
      if (row.bank && row.bank.name) html.push(row.bank.name);
      if (row.settings?.checkNo) html.push(`Check #${row.settings?.checkNo}`);
      // if (row.settings?.originalAmt) html.push(`Original Amt: ${currency(row.settings?.originalAmt)}`);
      // else html.push(`Original Amt: ${currency(row.settings?.originalAmt)}`);
      break;
    case PAYMENT_TYPE.CREDIT:
      html.push(row.settings?.cardType);
      if (row.settings?.cardNumber) html.push(`xxx${row.settings?.cardNumber}`);
      break;
    default:
      break;
  }
  return html.join(',');
};

export const displayInvoice = ({ id, invoiceNumber }, currentState, onViewInvoice) => {
  const ACCESS = getAccess(currentState);
  return (
    <>
      {isAccessible(ACCESS.ACTION.INVOICE.VIEW, currentState) ? (
        <div className="link" onClick={() => onViewInvoice({ id })}>
          {invoiceNumber || ''}
        </div>
      ) : (
        invoiceNumber || ''
      )}
    </>
  );
};

export const deriveInvoiceNo = (row) => {
  let inv = getInvoice(row);
  const type = row.type || INVOICE;
  if (inv) return inv?.invoiceNumber || '';
  if (type === REFUND || type === REFUND_CREDIT) {
    const invoiceNumber = inv?.invoiceNumber || row.refund?.invoiceNumber || '';
    if (invoiceNumber) return invoiceNumber;
    if (row.refund?.isCredit) return toCreditId(row.refund?.id);
    return toRefundId(row.refund?.id);
  } else if (type === CREDIT) {
    return toCreditId(row.credit?.id);
  }
  // else if (type === REFUND_CREDIT) {
  //   return toRefundCreditId(row.refund?.id);
  // }
  if (type === PAYMENT) {
    const invoiceNos = (row.paymentGroup.payments || []).map((p) => p.invoiceNumber || '');
    return invoiceNos.join();
  }
  return '';
};

export const renderInvoiceNo = (row, currentState, onViewInvoice) => {
  const inv = getInvoice(row);
  const invoiceNo = deriveInvoiceNo(row);
  if (inv) {
    return displayInvoice(inv, currentState, onViewInvoice);
  }
  if (row.type === PAYMENT) {
    return (
      <>
        {(row.paymentGroup?.payments || []).map((p) => (
          <div>
            {p.invoiceNumber || ''}
            {/* {displayInvoice({ id: p.invoiceId, invoiceNumber: p.invoiceNumber }, currentState, onViewInvoice)} */}
          </div>
        ))}
      </>
    );
  }
  if (row.type === REFUND_CREDIT) {
    return (
      <>{displayInvoice({ id: row.invoiceId, invoiceNumber: invoiceNo }, currentState, onViewInvoice)}</>
    );
  }

  return (
    <div>
      {(row.type === INVOICE || row.type === REFUND) && (
        <>
          {displayInvoice(
            { id: row.invoiceId, invoiceNumber: inv?.invoiceNumber },
            currentState,
            onViewInvoice,
          )}
        </>
      )}
      {(row.type === REFUND || row.type === REFUND_CREDIT) && (
        <>{displayInvoice({ id: row.invoiceId, invoiceNumber: invoiceNo }, currentState, onViewInvoice)}</>
      )}
      {row.type === CREDIT && row.credit?.simple && <div>{invoiceNo || ''}</div>}
      {row.type === CREDIT && !row.credit?.simple && <>{invoiceNo || ''}</>}
    </div>
  );
};

export const deriveDueDate = (row) => {
  const inv = getInvoice(row);
  if (!inv) return '';
  return format(inv.dueDate || '', DATE_FORMATS.DATE_WEEKDAY) || '';
};

export const deriveDeliveryDate = (row) => {
  const inv = getInvoice(row);
  if (!inv) return '';
  return format(inv.order?.deliveryDate || '', DATE_FORMATS.DATE_WEEKDAY) || '';
};

export const creditStatusPicker = (row, onChangeStatus, ACCESS) => {
  const { credit } = row;

  const adjustableStatuses = [REFUND_STATUS.PROCESSED, REFUND_STATUS.VOID];

  return !credit || !adjustableStatuses.includes(credit.status) ? (
    <>{deriveStatus(row)}</>
  ) : (
    <>
      <Select
        variant="outlined"
        className={`xsmall ${accessDisable(ACCESS.ACTION.CREDIT.CHANGE_STATUS)}`}
        value={credit.status}
        onChange={(e) => onChangeStatus(credit.id, e.target.value, row)}>
        {generateSelectOptions(REFUND_STATUS_OPTIONS, credit.status, true)}
      </Select>
    </>
  );
};

export const deriveStatus = (row) => {
  let status;
  const inv = getInvoice(row);
  if (inv) {
    status = inv.status;
  }
  let type = row.type || INVOICE;
  if (type === REFUND) status = intl(row.refund?.status) || '';
  if (row.refund && !row.refund?.isCredit) {
    type = REFUND;
    status = row.refund?.status;
  }
  if (type === CREDIT) {
    status = 'PROCESSED';
    type = REFUND;
  }
  if (type === PAYMENT && row.paymentGroup?.rejectedAt) {
    return 'Rejected';
  }

  if (status) {
    return intl('INPUT.OPTION.' + type + '_STATUS.' + status) || status;
  } else {
    return '';
  }
};

export const deriveInvoiceField = (row, key, useIntl = false) => {
  const inv = getInvoice(row);
  if (!inv) return '';
  let content = _.get(inv, key);
  if (key === 'order.status') content = intl('INPUT.OPTION.ORDER_STATUS.' + content, undefined, true);
  return useIntl ? intl(content) : content;
};

export const verifyInactiveActivity = async (store, item = 'Invoice', resolveCallback) => {
  return new Promise((resolve, reject) => {
    if (store?.active === undefined || store.active) {
      resolve(true);
      return;
    }
    dialog.confirm({
      title: 'MESSAGE.WAIT',
      message: 'MESSAGE.INACTIVE_ACTIVITY_WARNING',
      buttons: [
        {
          text: intl('BUTTON.CANCEL'),
          handler: () => reject(false),
        },
        {
          text: intl('BUTTON.REACTIVATE'),
          handler: () => {
            resolveCallback();
            reject(false);
            return;
          },
        },
        {
          text: intl('BUTTON.WORK_ONLY', { item }),
          handler: () => {
            resolve(true);
            return;
          },
        },
      ],
    });
    return;
  });
};

export const deriveStatusColumn = ({
  row,
  deleteInvoice,
  currentState,
  onChangeStatus,
  isEcommerce,
  onChangeRefundStatus,
  ACCESS,
}) => {
  const inv = getInvoice(row);
  if (row.type === CREDIT) {
    return creditStatusPicker(row, onChangeRefundStatus, ACCESS);
  }
  if (!inv) {
    return <>{deriveStatus(row)}</>;
  }
  let options;
  switch (inv.status) {
    case INVOICE_STATUS.CANCELLED:
      options = CANCELLED_OPTIONS;
      break;
    case INVOICE_STATUS.VOID_PAYMENT:
      options = VOID_PAYMENT_OPTIONS;
      break;
    case INVOICE_STATUS.PAID:
      options = CLOSE_OPTIONS.map((p) => {
        if (p.value === INVOICE_STATUS.VOID_PAYMENT) {
          return {
            ...p,
            disabled: inv.refunds?.length > 0 ? true : false,
          };
        }
        return p;
      });
      break;
    case INVOICE_STATUS.REFUNDED:
      options = REFUNDED_OPTIONS;
      break;
    default:
      options = [
        ...OPEN_OPTIONS,
        ...(inv.paidAmount > 0 || inv.creditAmount > 0 || inv.paymentDiscount
          ? [INVOICE_STATUS.VOID_PAYMENT].map(convertToOption)
          : [INVOICE_STATUS.CANCELLED].map(convertToOption)),
        ...(inv.balance <= 0 ? [INVOICE_STATUS.PAID].map(convertToOption) : []),
        ...(deleteInvoice ? [INVOICE_STATUS.DELETE].map(convertToOption) : []),
      ];
      break;
  }
  return (inv.closedAt || isEcommerce) && isAccessible(ACCESS.ACTION.INVOICE.CHANGE_STATUS, currentState) ? (
    <>
      <Select
        variant="outlined"
        className="xsmall"
        value={inv.status}
        onChange={(e) => onChangeStatus(inv, e.target.value)}>
        {generateSelectOptions(options, inv.status, !!inv?.payments?.length)}
      </Select>
    </>
  ) : (
    <div>{deriveStatus(row)}</div>
  );
};
